export default {"src":"/_next/static/media/sphere.f8d3ba36.svg","height":242,"width":242,"blurWidth":0,"blurHeight":0};